<template>
  <div class="nav-bar" :class="{ 'nav-bar--collapsed': isCollapse }">
    <router-link
      :to="{ name: 'Employees' }"
      class="nav-bar__logo  hide-md  hide-sm  hide-xs"
    >
      <span class="nav-bar__logo-icon" />
      <transition name="fade">
        <span v-if="!isCollapse" class="nav-bar__logo-text">Wiplan</span>
      </transition>
    </router-link>
    <div class="nav-bar__content">
      <div class="nav-bar__menu">
        <router-link :to="{ name: 'Projects' }" class="nav-bar__menu-item">
          <span class="nav-bar__menu-item__icon">
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path d="M6 13.5H9V15H6V13.5Z" fill="#9A99CC" />
              <path d="M10.5 13.5H13.5V15H10.5V13.5Z" fill="#9A99CC" />
              <path d="M6 10.5H9V12H6V10.5Z" fill="#9A99CC" />
              <path d="M10.5 16.5H13.5V18H10.5V16.5Z" fill="#9A99CC" />
              <path d="M15 10.5H18V12H15V10.5Z" fill="#9A99CC" />
              <path d="M15 16.5H18V18H15V16.5Z" fill="#9A99CC" />
              <path
                d="M20.25 2.25H3.75C3.3523 2.2504 2.971 2.40856 2.68978 2.68978C2.40856 2.971 2.2504 3.3523 2.25 3.75V20.25C2.2504 20.6477 2.40856 21.029 2.68978 21.3102C2.971 21.5914 3.3523 21.7496 3.75 21.75H20.25C20.6477 21.7496 21.029 21.5914 21.3102 21.3102C21.5914 21.029 21.7496 20.6477 21.75 20.25V3.75C21.7496 3.3523 21.5914 2.971 21.3102 2.68978C21.029 2.40856 20.6477 2.2504 20.25 2.25ZM20.25 3.75V6.75H3.75V3.75H20.25ZM3.75 20.25V8.25H20.25V20.25H3.75Z"
                fill="#9A99CC"
              />
            </svg>
          </span>
          <transition name="fade">
            <span v-if="!isCollapse" class="nav-bar__menu-item__text">
              Проекты
            </span>
          </transition>
        </router-link>
        <router-link :to="{ name: 'Employees' }" class="nav-bar__menu-item">
          <span class="nav-bar__menu-item__icon">
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M22.5 21C22.5 21 24 21 24 19.5C24 18 22.5 13.5 16.5 13.5C10.5 13.5 9 18 9 19.5C9 21 10.5 21 10.5 21H22.5ZM10.5075 19.584V19.581V19.584ZM10.533 19.5H22.467C22.474 19.4992 22.481 19.4982 22.488 19.497L22.5 19.494C22.497 19.098 22.2495 17.949 21.36 16.914C20.532 15.9435 19.077 15 16.5 15C13.9245 15 12.4695 15.945 11.64 16.914C10.7505 17.949 10.5015 19.0995 10.5 19.494C10.511 19.4961 10.522 19.4981 10.533 19.5ZM22.4925 19.584V19.581V19.584ZM16.5 10.5C17.2956 10.5 18.0587 10.1839 18.6213 9.62132C19.1839 9.05871 19.5 8.29565 19.5 7.5C19.5 6.70435 19.1839 5.94129 18.6213 5.37868C18.0587 4.81607 17.2956 4.5 16.5 4.5C15.7044 4.5 14.9413 4.81607 14.3787 5.37868C13.8161 5.94129 13.5 6.70435 13.5 7.5C13.5 8.29565 13.8161 9.05871 14.3787 9.62132C14.9413 10.1839 15.7044 10.5 16.5 10.5ZM21 7.5C21 8.09095 20.8836 8.67611 20.6575 9.22208C20.4313 9.76804 20.0998 10.2641 19.682 10.682C19.2641 11.0998 18.768 11.4313 18.2221 11.6575C17.6761 11.8836 17.0909 12 16.5 12C15.9091 12 15.3239 11.8836 14.7779 11.6575C14.232 11.4313 13.7359 11.0998 13.318 10.682C12.9002 10.2641 12.5687 9.76804 12.3425 9.22208C12.1164 8.67611 12 8.09095 12 7.5C12 6.30653 12.4741 5.16193 13.318 4.31802C14.1619 3.47411 15.3065 3 16.5 3C17.6935 3 18.8381 3.47411 19.682 4.31802C20.5259 5.16193 21 6.30653 21 7.5ZM10.404 13.92C9.80397 13.7311 9.18545 13.6069 8.559 13.5495C8.207 13.516 7.85359 13.4995 7.5 13.5C1.5 13.5 0 18 0 19.5C0 20.5005 0.4995 21 1.5 21H7.824C7.60163 20.5317 7.49074 20.0183 7.5 19.5C7.5 17.985 8.0655 16.437 9.135 15.144C9.4995 14.703 9.924 14.2905 10.404 13.92ZM7.38 15C4.878 15.03 3.4575 15.96 2.64 16.914C1.7445 17.955 1.5 19.1085 1.5 19.5H6C6 17.9325 6.4845 16.371 7.38 15ZM2.25 8.25C2.25 7.05653 2.72411 5.91193 3.56802 5.06802C4.41193 4.22411 5.55653 3.75 6.75 3.75C7.94347 3.75 9.08807 4.22411 9.93198 5.06802C10.7759 5.91193 11.25 7.05653 11.25 8.25C11.25 9.44347 10.7759 10.5881 9.93198 11.432C9.08807 12.2759 7.94347 12.75 6.75 12.75C5.55653 12.75 4.41193 12.2759 3.56802 11.432C2.72411 10.5881 2.25 9.44347 2.25 8.25ZM6.75 5.25C5.95435 5.25 5.19129 5.56607 4.62868 6.12868C4.06607 6.69129 3.75 7.45435 3.75 8.25C3.75 9.04565 4.06607 9.80871 4.62868 10.3713C5.19129 10.9339 5.95435 11.25 6.75 11.25C7.54565 11.25 8.30871 10.9339 8.87132 10.3713C9.43393 9.80871 9.75 9.04565 9.75 8.25C9.75 7.45435 9.43393 6.69129 8.87132 6.12868C8.30871 5.56607 7.54565 5.25 6.75 5.25Z"
                fill="#9A99CC"
              />
            </svg>
          </span>
          <transition name="fade">
            <span v-if="!isCollapse" class="nav-bar__menu-item__text">
              Пользователи
            </span>
          </transition>
        </router-link>
        <router-link :to="{ name: 'Professions' }" class="nav-bar__menu-item">
          <span class="nav-bar__menu-item__icon">
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M3.9375 2.0625L3.51525 2.46075L2.46075 3.51525L2.0625 3.9375L2.367 4.4295L3.9375 7.0545L4.14825 7.4295H6.3525L9.3525 10.4062C6.672 13.0988 3.26175 16.5202 3.14175 16.641C1.9665 17.8155 1.96425 19.74 3.16425 20.8597C4.3365 22.0163 6.24675 22.0462 7.3605 20.8597L7.383 20.8358L12 16.1955L16.641 20.859L16.7108 20.9062C17.8883 22.0163 19.761 22.0312 20.8597 20.859V20.8365H20.8822C22.0312 19.6612 22.0432 17.751 20.8597 16.6403L20.8358 16.6178L16.9222 12.7267C19.5555 12.4808 21.618 10.257 21.6562 7.5705H21.6795C21.6825 7.5555 21.6795 7.53825 21.6795 7.52325V7.5C21.753 6.633 21.5655 5.8035 21.117 5.08575L20.6025 4.29L17.1097 7.782L16.0553 6.68025L19.6178 3.11775L18.5865 2.69625C17.9287 2.40686 17.2186 2.255 16.5 2.25C13.617 2.25 11.25 4.617 11.25 7.5C11.25 7.8135 11.3175 8.08575 11.367 8.367C11.0393 8.6955 10.7933 8.96475 10.4062 9.35175L7.4295 6.375V4.14825L7.0545 3.9375L4.4295 2.367L3.9375 2.0625ZM16.5 3.75C16.605 3.75 16.6785 3.8115 16.7812 3.8205L13.9455 6.65625L14.4608 7.1955L16.5705 9.375L17.0858 9.91425L20.0625 6.9375C20.0775 7.11 20.2005 7.236 20.1795 7.4295V7.5C20.1795 9.5655 18.495 11.25 16.4295 11.25C16.1543 11.25 15.8205 11.1855 15.4455 11.109L15.0465 11.0392L14.7653 11.3205L6.30525 19.8045H6.28125V19.8285C5.74875 20.4112 4.8165 20.4255 4.1955 19.8045V19.7812H4.1715C3.58875 19.2488 3.5745 18.3165 4.1955 17.6955C4.47975 17.4105 9.984 11.859 12.6795 9.16425L12.9847 8.85975L12.867 8.4375C12.7958 8.12986 12.7566 7.8157 12.75 7.5C12.75 5.4345 14.4345 3.75 16.5 3.75ZM4.1715 3.9375L5.9295 5.016V5.766L5.766 5.9295H5.016L3.9375 4.17225L4.1715 3.9375ZM15.1403 13.0545L19.8053 17.6955V17.7188H19.8278C20.4113 18.2512 20.4255 19.1835 19.8053 19.8045H19.7812V19.8285C19.2488 20.4112 18.3165 20.4255 17.6955 19.8045L13.0545 15.141L15.1403 13.0545Z"
                fill="#9A99CC"
              />
            </svg>
          </span>
          <transition name="fade">
            <span v-if="!isCollapse" class="nav-bar__menu-item__text">
              Специальности
            </span>
          </transition>
        </router-link>
        <router-link :to="{ name: 'Companies' }" class="nav-bar__menu-item">
          <span class="nav-bar__menu-item__icon">
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M20 6C20.58 6 21.05 6.2 21.42 6.59C21.8 7 22 7.45 22 8V19C22 19.55 21.8 20 21.42 20.41C21.05 20.8 20.58 21 20 21H4C3.42 21 2.95 20.8 2.58 20.41C2.2 20 2 19.55 2 19V8C2 7.45 2.2 7 2.58 6.59C2.95 6.2 3.42 6 4 6H8V4C8 3.42 8.2 2.95 8.58 2.58C8.95 2.2 9.42 2 10 2H14C14.58 2 15.05 2.2 15.42 2.58C15.8 2.95 16 3.42 16 4V6H20ZM4 8V19H20V8H4ZM14 6V4H10V6H14Z"
                fill="#9A99CC"
              />
            </svg>
          </span>
          <transition name="fade">
            <span v-if="!isCollapse" class="nav-bar__menu-item__text">
              {{ userRole === "manager" ? "О компании" : "Компании" }}
            </span>
          </transition>
        </router-link>
        <router-link :to="{ name: 'Tariffs' }" class="nav-bar__menu-item">
          <span class="nav-bar__menu-item__icon">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 267 267"
            >
              <g>
                <path
                  d="M133.333 12.5c66.69 0 120.834 54.144 120.834 120.833 0 66.69-54.144 120.834-120.834 120.834-66.689 0-120.833-54.144-120.833-120.834C12.5 66.644 66.644 12.5 133.333 12.5zm0 16.667c-57.491 0-104.166 46.675-104.166 104.166S75.842 237.5 133.333 237.5 237.5 190.824 237.5 133.333 190.824 29.167 133.333 29.167z"
                  fill="#9A99CC"
                />
                <path
                  d="M87.5 104.167c0-20.711 16.789-37.5 37.5-37.5h50v16.666h-50c-11.506 0-20.833 9.328-20.833 20.834m0 0A20.833 20.833 0 0 0 125 125h20.842a37.491 37.491 0 0 1 37.491 37.492v.008c0 20.711-16.789 37.5-37.5 37.5h-50v-16.667h50.001c11.505 0 20.833-9.327 20.833-20.833v-.008a20.826 20.826 0 0 0-20.825-20.825H125a37.498 37.498 0 0 1-37.5-37.5"
                  fill="#9A99CC"
                />
                <path d="M125 50h16.667v166.667H125z" fill="#9A99CC" />
              </g>
            </svg>
          </span>
          <transition name="fade">
            <span v-if="!isCollapse" class="nav-bar__menu-item__text">
              Тарифы
            </span>
          </transition>
        </router-link>
        <router-link :to="{ name: 'Help' }" class="nav-bar__menu-item">
          <span class="nav-bar__menu-item__icon">
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M2 7C2 5.67392 2.52678 4.40215 3.46447 3.46447C4.40215 2.52678 5.67392 2 7 2H17C18.3261 2 19.5979 2.52678 20.5355 3.46447C21.4732 4.40215 22 5.67392 22 7V17C22 18.3261 21.4732 19.5979 20.5355 20.5355C19.5979 21.4732 18.3261 22 17 22H7C5.67392 22 4.40215 21.4732 3.46447 20.5355C2.52678 19.5979 2 18.3261 2 17V7ZM7 4C6.20435 4 5.44129 4.31607 4.87868 4.87868C4.31607 5.44129 4 6.20435 4 7V17C4 17.7956 4.31607 18.5587 4.87868 19.1213C5.44129 19.6839 6.20435 20 7 20H17C17.7956 20 18.5587 19.6839 19.1213 19.1213C19.6839 18.5587 20 17.7956 20 17V7C20 6.20435 19.6839 5.44129 19.1213 4.87868C18.5587 4.31607 17.7956 4 17 4H7ZM12 7.5C10.552 7.5 10 8.552 10 9C10 9.26522 9.89464 9.51957 9.70711 9.70711C9.51957 9.89464 9.26522 10 9 10C8.73478 10 8.48043 9.89464 8.29289 9.70711C8.10536 9.51957 8 9.26522 8 9C8 7.448 9.448 5.5 12 5.5C13.156 5.5 14.17 5.789 14.909 6.435C15.664 7.096 16 8.017 16 9C16 10.188 15.694 11.028 15.118 11.668C14.8721 11.9328 14.5939 12.1656 14.29 12.361C14.1685 12.4411 14.0458 12.5195 13.922 12.596L13.904 12.607C13.78 12.685 13.668 12.757 13.557 12.83C13.207 13.066 13.064 13.242 13.007 13.356C12.961 13.444 12.93 13.561 12.979 13.794C13.0061 13.9226 13.0075 14.0552 12.9833 14.1843C12.9591 14.3135 12.9097 14.4366 12.8379 14.5466C12.693 14.7688 12.4656 14.9244 12.206 14.979C12.0774 15.0061 11.9448 15.0075 11.8157 14.9833C11.6865 14.9591 11.5634 14.9097 11.4534 14.8379C11.2312 14.693 11.0756 14.4656 11.021 14.206C10.895 13.606 10.938 13.009 11.225 12.447C11.498 11.912 11.943 11.505 12.443 11.17C12.583 11.076 12.72 10.99 12.842 10.913L12.851 10.907C12.973 10.831 13.079 10.765 13.179 10.697C13.384 10.561 13.525 10.447 13.632 10.329C13.806 10.136 14 9.813 14 9C14 8.483 13.836 8.154 13.591 7.94C13.33 7.711 12.844 7.5 12 7.5ZM12 15.781C11.8687 15.781 11.7386 15.8069 11.6173 15.8571C11.496 15.9074 11.3858 15.981 11.2929 16.0739C11.2 16.1668 11.1264 16.277 11.0761 16.3983C11.0259 16.5196 11 16.6497 11 16.781C11 16.9123 11.0259 17.0424 11.0761 17.1637C11.1264 17.285 11.2 17.3952 11.2929 17.4881C11.3858 17.581 11.496 17.6546 11.6173 17.7049C11.7386 17.7551 11.8687 17.781 12 17.781C12.2652 17.781 12.5196 17.6756 12.7071 17.4881C12.8946 17.3006 13 17.0462 13 16.781C13 16.5158 12.8946 16.2614 12.7071 16.0739C12.5196 15.8864 12.2652 15.781 12 15.781Z"
                fill="#9A99CC"
              />
            </svg>
          </span>
          <transition name="fade">
            <span v-if="!isCollapse" class="nav-bar__menu-item__text">
              Помощь
            </span>
          </transition>
        </router-link>
      </div>
      <div
        class="nav-bar__switch  hide-md  hide-sm  hide-xs"
        @click="changeView"
      >
        <div class="nav-bar__switch-icon">
          <img src="@/assets/icons/icon-collapse.svg" alt="" />
        </div>
        <transition name="fade">
          <div v-if="!isCollapse" class="nav-bar__switch-text">
            Свернуть
          </div>
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
import breakpoints from "../../js/breakpoints";

export default {
  name: "Sidebar",
  data() {
    return {
      isCollapse: false
    };
  },
  computed: {
    userRole() {
      return this.$store.state.Auth.userRole;
    }
  },
  methods: {
    changeView() {
      this.isCollapse = !this.isCollapse;
      this.$emit("change-view", this.isCollapse);
    },
    resizeNavigation() {
      if (
        window.innerWidth < breakpoints["lg-max"] &&
        window.innerWidth > breakpoints["lg-min"]
      ) {
        this.isCollapse = true;
        this.$emit("change-view", this.isCollapse);
      } else {
        this.isCollapse = false;
        this.$emit("change-view", this.isCollapse);
      }
    }
  },
  created() {
    this.resizeNavigation();
    window.addEventListener("resize", this.resizeNavigation);
  },
  destroyed() {
    window.removeEventListener("resize", this.resizeNavigation);
  }
};
</script>

<style scoped lang="scss">
@import "src/assets/styles/helpers/variables";
@import "src/assets/styles/helpers/mixin";

.nav-bar {
  width: 24rem;
  max-width: 24rem;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  transition: 0.3s ease-out;
  overflow: hidden;
  z-index: 20;

  svg {
    vertical-align: top;
  }

  &--collapsed {
    max-width: 7.2rem;

    .nav-bar {
      &__logo {
        padding: 0 2rem;
      }

      &__menu {
        &-item {
          padding: 1.4rem 2.2rem;
        }
      }

      &__switch {
        padding: 0 2.8rem;

        &-icon {
          transform: scale(-1, 1);
        }
      }
    }
  }

  &__logo {
    background: #fff;
    box-shadow: 4px 4px 24px rgba(70, 80, 119, 0.04);
    height: 7.4rem;
    padding: 0 3.2rem;
    display: flex;
    align-items: center;
    text-decoration: none;

    &-icon {
      display: block;
      width: 5.9rem;
      max-width: 100%;
      height: 3rem;
      background-image: url("data:image/svg+xml,%3Csvg width='59' height='30' viewBox='0 0 59 30' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M24.0156 18.612L28.8188 13.8089L34.9727 19.8878L54.035 0.750488L58.838 5.55358L34.9727 29.494L24.0156 18.612Z' fill='%23E1AD27'/%3E%3Cpath d='M0 17.8615L4.8031 13.0584L10.9571 19.1373L30.0194 0L34.8224 4.80309L10.9571 28.7435L0 17.8615Z' fill='%231DA4F4'/%3E%3C/svg%3E%0A");
      background-repeat: no-repeat;
      background-position: center;
      background-size: contain;
    }

    &-text {
      font-weight: 600;
      font-size: 0;
      line-height: 0;
      text-transform: uppercase;
      color: #10a1fe;
      margin-left: 1rem;
      width: 5.9rem;
      max-width: 100%;
      height: 1.9rem;
      background-image: url("data:image/svg+xml,%3Csvg width='59' height='19' viewBox='0 0 59 19' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M5.58661 8.85933L5.84265 11.3016H5.92143L6.19716 8.81994L8.60001 1.15842H10.3726L12.7361 8.85933L13.0118 11.3016H13.0906L13.386 8.81994L15.0601 1.15842H17.7978L13.9966 15.0437H12.1846L9.72265 7.38217L9.38783 5.27476H9.28935L8.95452 7.40187L6.51229 15.0437H4.60184L0.820312 1.15842H3.75493L5.58661 8.85933ZM19.1628 5.0975H21.7232V14.9452H19.1628V5.0975ZM18.7886 2.32045C18.7886 1.93964 18.9264 1.61798 19.2022 1.35538C19.491 1.07964 19.8849 0.941772 20.3839 0.941772C20.8829 0.941772 21.2833 1.07964 21.5853 1.35538C21.9004 1.61798 22.058 1.93964 22.058 2.32045C22.058 2.70126 21.9004 3.02289 21.5853 3.28553C21.2833 3.53497 20.8829 3.65974 20.3839 3.65974C19.8849 3.65974 19.491 3.53497 19.2022 3.28553C18.9264 3.02289 18.7886 2.70126 18.7886 2.32045ZM24.2157 5.0975H26.0868L26.3822 6.27923H26.461C26.8024 5.78025 27.2028 5.41263 27.6624 5.17629C28.1351 4.93994 28.7063 4.82177 29.3759 4.82177C30.6106 4.82177 31.5363 5.21568 32.1528 6.00349C32.7702 6.77821 33.0785 8.03212 33.0785 9.76532C33.0785 10.6056 32.98 11.3672 32.783 12.05C32.5861 12.7196 32.2907 13.2908 31.8967 13.7635C31.5166 14.2362 31.0439 14.5973 30.4787 14.8467C29.9272 15.0962 29.2906 15.2209 28.5684 15.2209C28.1614 15.2209 27.8266 15.1882 27.564 15.1225C27.3013 15.07 27.0388 14.978 26.7761 14.8467V18.8843H24.2157V5.0975ZM28.6078 6.98826C28.1088 6.98826 27.7149 7.11304 27.4261 7.36248C27.1504 7.61192 26.9337 7.98613 26.7761 8.48512V12.5818C26.96 12.7262 27.157 12.8444 27.367 12.9363C27.5902 13.0151 27.8791 13.0545 28.2336 13.0545C28.9689 13.0545 29.5205 12.7984 29.8878 12.2863C30.2561 11.7612 30.4393 10.9011 30.4393 9.70623C30.4393 8.83963 30.2955 8.16999 30.006 7.6973C29.7175 7.22461 29.2512 6.98826 28.6078 6.98826ZM37.4912 11.6364C37.4912 12.096 37.5503 12.4308 37.6685 12.6408C37.7867 12.8509 37.9767 12.956 38.2397 12.956C38.3972 12.956 38.5479 12.9429 38.6927 12.9166C38.8502 12.8903 39.0403 12.8312 39.2638 12.7393L39.5396 14.7483C39.3298 14.8533 39.0078 14.9583 38.5745 15.0634C38.1412 15.1685 37.6951 15.2209 37.2352 15.2209C36.4868 15.2209 35.9156 15.0503 35.5217 14.7089C35.1278 14.3544 34.9308 13.7766 34.9308 12.9757V1.15842H37.4912V11.6364ZM40.5824 5.66867C41.1073 5.43233 41.7317 5.24847 42.4535 5.1172C43.1753 4.97273 43.9307 4.90055 44.7185 4.90055C45.4009 4.90055 45.9721 4.98593 46.432 5.15659C46.8919 5.31416 47.2523 5.5439 47.5152 5.84593C47.791 6.14796 47.981 6.50898 48.0864 6.92918C48.2046 7.34938 48.2637 7.82207 48.2637 8.34725C48.2637 8.92501 48.244 9.50928 48.2046 10.1001C48.1652 10.6779 48.1386 11.2491 48.1258 11.8136C48.1258 12.3782 48.1455 12.9297 48.1849 13.4681C48.2243 13.9932 48.3227 14.4922 48.4803 14.9649H46.3926L45.979 13.6059H45.8805C45.6176 14.0129 45.2503 14.3674 44.7776 14.6695C44.3177 14.9583 43.7209 15.1028 42.9853 15.1028C42.5254 15.1028 42.1118 15.0371 41.7445 14.9058C41.3771 14.7614 41.062 14.5644 40.7991 14.315C40.5362 14.0523 40.3333 13.7504 40.1885 13.409C40.0438 13.0545 39.9719 12.6605 39.9719 12.2272C39.9719 11.6233 40.1029 11.1177 40.3658 10.7107C40.6415 10.2905 41.0285 9.95568 41.5278 9.70623C42.0399 9.44359 42.6436 9.26633 43.3398 9.17446C44.0488 9.06938 44.8367 9.03659 45.7033 9.07598C45.7948 8.34065 45.7426 7.81547 45.5457 7.50035C45.3487 7.17212 44.9085 7.00796 44.2261 7.00796C43.714 7.00796 43.1694 7.06045 42.5914 7.16552C42.0271 7.2706 41.5603 7.40847 41.193 7.57913L40.5824 5.66867ZM43.8322 12.9954C44.3443 12.9954 44.751 12.8838 45.0533 12.6605C45.3556 12.4242 45.5782 12.1748 45.7229 11.9121V10.6319C45.3162 10.5925 44.9223 10.5859 44.5412 10.6122C44.1739 10.6385 43.845 10.6976 43.5564 10.7895C43.2679 10.8814 43.0375 11.0127 42.8671 11.1834C42.6967 11.354 42.6111 11.5707 42.6111 11.8333C42.6111 12.201 42.7164 12.4899 42.9262 12.6999C43.1497 12.8969 43.4511 12.9954 43.8322 12.9954ZM56.4392 14.9452V9.35171C56.4392 8.5508 56.3211 7.97304 56.0847 7.61852C55.8612 7.264 55.4742 7.08674 54.9227 7.08674C54.4362 7.08674 54.0226 7.23121 53.6819 7.52004C53.353 7.79578 53.1166 8.1437 52.9728 8.5639V14.9452H50.4124V5.0975H52.4411L52.7365 6.3974H52.8153C53.1166 5.9772 53.5174 5.60959 54.0167 5.29446C54.515 4.97933 55.159 4.82177 55.9469 4.82177C56.4323 4.82177 56.8656 4.88745 57.2467 5.01872C57.6269 5.14999 57.9489 5.36664 58.2118 5.66867C58.4738 5.9707 58.6707 6.3843 58.8027 6.90948C58.9337 7.42156 58.9996 8.05842 58.9996 8.81994V14.9452H56.4392Z' fill='%231DA4F4'/%3E%3C/svg%3E%0A");
      background-repeat: no-repeat;
      background-position: center;
      background-size: contain;
    }
  }

  &__content {
    height: calc(100% - 7.4rem);
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    background: linear-gradient(180deg, #0d0c56 0%, #103887 100%);
    box-shadow: 4px 4px 24px rgba(70, 80, 119, 0.04);
    padding: 4.2rem 0;
  }

  &__menu {
    display: flex;
    flex-direction: column;
    padding: 0 0.4rem;

    &-item {
      display: flex;
      align-items: center;
      color: #9a99cc;
      font-weight: 600;
      font-size: 1.6rem;
      line-height: 2.2rem;
      text-decoration: none;
      padding: 1.4rem 3rem;
      border-radius: 6px;
      background: transparent;
      transition: all $transition-duration;

      path {
        transition: fill $transition-duration;
      }

      &.router-link-exact-active,
      &:hover {
        background: linear-gradient(
          180deg,
          rgba(99, 188, 245, 0.25) -29.17%,
          rgba(17, 153, 240, 0.25) 100%
        );
        color: #f1f8ff;

        path {
          fill: #f1f8ff;
        }
      }

      &.router-link-exact-active {
        cursor: default;
      }

      &:last-of-type {
        margin-bottom: 0;
      }

      &__text {
        margin-left: 1rem;
        white-space: nowrap;
      }
    }
  }

  &__switch {
    display: flex;
    align-items: center;
    color: #f1f8ff;
    font-weight: 600;
    font-size: 1.6rem;
    line-height: 2.2rem;
    cursor: pointer;
    padding: 0 3.4rem;

    &-icon {
      margin-right: 1rem;
      transition: 0.3s ease-out;
    }
  }
}

@media (max-width: $screen-md-max) {
  .nav-bar {
    top: auto;
    bottom: 0;
    height: auto;
    width: 100%;
    max-width: none;
    border-top: 1px solid #e3e5ec;
    overflow: visible;
  }
  .nav-bar__content {
    flex-direction: row;
    padding: 0 16px;
    background-color: #fff;
    background-image: none;
  }
  .nav-bar__menu {
    flex-direction: row;
    width: 100%;
    justify-content: space-between;
  }
  .nav-bar__menu-item {
    position: relative;
    padding: 0;
    padding-bottom: 3px;
    height: 60px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    color: #a1adbb;
    filter: brightness(0) saturate(100%) invert(71%) sepia(13%) saturate(307%)
      hue-rotate(172deg) brightness(95%) contrast(91%);

    @include no-touch {
      &:hover {
        background-image: none;
        filter: brightness(0) saturate(100%) invert(47%) sepia(36%)
          saturate(1964%) hue-rotate(172deg) brightness(98%) contrast(92%);

        &::before {
          opacity: 1;
        }
      }
    }

    &.router-link-exact-active {
      background-image: none;
      filter: brightness(0) saturate(100%) invert(47%) sepia(36%)
        saturate(1964%) hue-rotate(172deg) brightness(98%) contrast(92%);

      &::before {
        opacity: 1;
      }
    }

    &::before {
      transition-duration: 300ms;
      height: 1px;
      width: 60px;
      content: "";
      top: -1px;
      left: 50%;
      position: absolute;
      transform: translateX(-50%);
      background: #1199f0;
      border-radius: 3px;
      opacity: 0;
    }
  }
  .nav-bar__menu-item__icon {
    color: inherit;
  }

  .nav-bar__menu-item__text {
    color: inherit;
    margin-left: 0;
    margin-top: 5px;
    font-weight: 400;
    font-size: 8px;
    line-height: 100%;
    text-align: center;
  }
}

@media (max-width: $screen-4xs-max) {
  .nav-bar__content {
    padding-left: 10px;
    padding-right: 10px;
  }
}
</style>
